import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { CsIconModule } from '@components/icon';
import { SwiperModule, SwiperComponent } from 'swiper/angular';
import { SwiperOptions } from 'swiper';
import { BroadcastService } from '@services/broadcast-service';
import { TreatmentPhilosophyCardComponent } from '../treatment-philosophy-card/treatment-philosophy-card.component';
import { TreatmentPhilosophyData } from '../../static-translations/treatment-content-translations';
import { LanguageService } from '@services/language-service/language.service';

@Component({
  selector: 'app-treatment-philosophy-widget',
  imports: [
    NgForOf,
    NgClass,
    CsIconModule,
    NgIf,
    SwiperModule,
    TreatmentPhilosophyCardComponent
  ],
  templateUrl: './treatment-philosophy-widget.component.html',
  standalone: true
})

export class TreatmentPhilosophyWidgetComponent implements OnInit {
  @Input() user: Table.User;
  @ViewChild('swiperComponent') swiperComponent?: SwiperComponent;
  protected readonly TreatmentPhilosophyData = TreatmentPhilosophyData;
  displayLanguage: string;

  constructor(
    private readonly broadcastService: BroadcastService,
    private readonly languageService: LanguageService
  ) {
  }
  showSelected: number | null = null;

  carouselConfig: SwiperOptions = {
    slidesPerView: 1.2,
    spaceBetween: 14,
    centeredSlides: true,
    initialSlide: 0,
    speed: 600,
    autoHeight: false
  };

  ngOnInit(): void {
    this.displayLanguage = this.languageService.getDisplayLanguage(this.user?.get('languagePreference'));
  }

  cardClick(id: number): void {
    this.broadcastService.broadcast('HOMEPAGE_FULLSCREEN_MODE_ON', { show: true });
    this.showSelected = id;
    this.carouselConfig = {
      ...this.carouselConfig,
      initialSlide: id
    };
    if (this.swiperComponent?.swiperRef) {
      this.swiperComponent.swiperRef.slideTo(id, 0);
      this.swiperComponent.swiperRef.update();
    }
  }

  closeSelected(): void {
    this.broadcastService.broadcast('HOMEPAGE_FULLSCREEN_MODE_OFF');
    this.showSelected = null;
  }
}
